<mat-card *ngIf="this.accountInfo?.limits.isMfaEnabled">
	<mat-progress-bar
		mode="indeterminate"
		*ngIf="!isDataLoaded"
		class="sdp-progress-bar"
	></mat-progress-bar>
	<div
		class="sdp-settings-skeleton-container"
		*ngIf="!isDataLoaded"
	>
		<div class="sdp-settings-skeleton-flex">
			<div class="sdp-settings-skeleton-line-container">
				<div class="sdp-settings-skeleton sdp-settings-skeleton-title"></div>
				<div class="sdp-settings-skeleton sdp-settings-skeleton-line"></div>
				<div class="sdp-settings-skeleton sdp-settings-skeleton-line"></div>
				<div class="sdp-settings-skeleton sdp-settings-skeleton-button"></div>
			</div>
		</div>
	</div>

	<div>
		<div>
			<h3 class="sdp-header-no-margin-top">{{ "settings.mfa.header" | translate }}</h3>
			<p *ngIf="state === MFA_SETUP_STATE.OFF">{{ "settings.mfa.description" | translate }}</p>
			<p *ngIf="state === MFA_SETUP_STATE.WAITING_FOR_TOTP && mfaSetupData.result">{{ "settings.mfa.instructions" | translate }}</p>
			<p *ngIf="state === MFA_SETUP_STATE.ON">{{ "settings.mfa.disableMfaDescription" | translate }} <b>{{authenticatorName}}</b>.</p>
		</div>

		<div
			class="sdp-form-control"
			*ngIf="errMessage && errMessage.length > 0"
		>
			<mat-card class="sdp-form-error-block">{{ errMessage | translate }}</mat-card>
		</div>

		<div
			*ngIf="state === MFA_SETUP_STATE.OFF"
			class="sdp-form-buttons-container"
		>
			<button
				mat-raised-button
				color="primary"
				(click)="requestMfaKey()"
			>{{ "settings.mfa.setupButton.text" | translate }}</button>
		</div>

		<div
			*ngIf="state === MFA_SETUP_STATE.ON"
			class="sdp-form-buttons-container"
		>
			<button
				mat-raised-button
				color="primary"
				(click)="disableMfa()"
			>{{ "settings.mfa.disableButton.text" | translate }}</button>
		</div>

		<div *ngIf="state === MFA_SETUP_STATE.WAITING_FOR_TOTP">
			<img
				[src]="mfaSetupData.dataURL"
				alt=""
				class="img-thumbnail"
				style="display:block;margin:auto"
			>
			<form
				[formGroup]="totpForm"
				class="form-group"
				(ngSubmit)="completeMfaSetup()"
			>
				<p *ngIf="state === MFA_SETUP_STATE.WAITING_FOR_TOTP && mfaSetupData.result">{{ "settings.mfa.instructions2" | translate }}</p>
				<mat-form-field class="sdp-form-control-input-container">
					<input
						matInput
						placeholder="{{ 'settings.mfa.totpCodeInput.text' | translate }}"
						type="string"
						formControlName="totpCode"
						autocomplete="off"
						class="form-control"
					>
					<mat-error *ngIf="totpForm.controls['totpCode'].hasError('invalidTotpCode')">{{ "error.message.totp" | translate }}</mat-error>
				</mat-form-field>
				<div class="sdp-form-buttons-container">
					<button
						class="sdp-button-small-text"
						(click)="cancelAction()"
						type="button"
						color="primary"
						mat-button
					>{{ "sdp.label.cancel" | translate }}</button>
					<button
						mat-raised-button
						color="primary"
						type="submit"
					>{{ "settings.mfa.completeSetupButton.text" | translate }}</button></div>
			</form>
		</div>
	</div>
</mat-card>